import jsan from 'jsan';
import serialize from './serialize';
import options from '../constants/options';
export default function (immutable, refs, customReplacer, customReviver) {
  return {
    stringify: function (data) {
      return jsan.stringify(data, serialize(immutable, refs, customReplacer, customReviver).replacer, undefined, options);
    },
    parse: function (data) {
      return jsan.parse(data, serialize(immutable, refs, customReplacer, customReviver).reviver);
    },
    serialize: serialize
  };
}
export { default as serialize } from './serialize';